import React from "react";
import * as Icons from "@web/assets/icons";
import * as TbIcons from "react-icons/tb";
import {Brainstorm} from "@web/assets/icons";

const defaultClasses = "" // "app-thescribe-ai-icon ";
/**
 * @summary Render an icon from the @web/assets/icons library
 * @param name
 * @param props
 * @param className
 * @return {JSX.Element}
 * @constructor
 */
export default function Icon({name, className, ...props}) {
  if (!name) return <Brainstorm className={className}/>;
  const TheIcon = TbIcons[name] || Icons[name];
  return TheIcon ? <TheIcon size={22} {...props} className={defaultClasses + " " + className}/> :
    <Brainstorm className={className}/>;
}
